import axios from 'axios';

const sendEmail = async (formData) => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/api/backend/webapi/v2/email',
      data: {
        formData,
      },
    });

    return res
  } catch (e) {
    console.log(e);
    return e.response;
  }

}

export default sendEmail;